import PropTypes from 'prop-types';

import { Abstrap } from '../..';

const propTypes = {
    ...Abstrap.propTypes,
    active: PropTypes.bool,
    disabled: PropTypes.bool,
};

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    active: false,
    disabled: false,
};

class PaginationItem extends Abstrap {

    getClassNameSchema() {
        const {
            active,
            className,
            disabled,
        } = this.props;
        return [
            'c-pagination__item',
            active ? 'c-pagination__item_active' : false,
            disabled ? 'c-pagination__item_disabled' : false,
            className,
        ];
    }

}

PaginationItem.propTypes = propTypes;

PaginationItem.defaultProps = defaultProps;

export default PaginationItem;
